<template>
  <div class="all">
    <!-- 底部 -->
    <mall-fotter></mall-fotter>
    <!-- 顶部导航 -->
    <mall-header></mall-header>
    <!-- 内容 -->
    <div class="content">
      <div class="content_detail">
        <!-- 标题 -->
        <div class="pageTitle ovh">
          <div class="pageTitleList f_l ovh" @click="goIndex">
            <p class="pageTitleListTable f_l">乐冰雪首页</p>
            <div class="pageTitleListImg f_l">
              <img src="../../static/index/right.png" />
            </div>
          </div>
          <div class="pageTitleList f_l ovh" v-if="address !== '' && address !== 'null' && address !== null">
            <p class="pageTitleListTable f_l">{{address}}</p>
            <div class="pageTitleListImg f_l">
              <img src="../../static/index/right.png" />
            </div>
          </div>
          <div class="pageTitleList f_l ovh">
            <p class="pageTitleListTable f_l">雪具</p>
            <div class="pageTitleListImg f_l">
              <img src="../../static/index/right.png" />
            </div>
          </div>
        </div>
        <!-- 日历及信息 -->
        <div class="commodityInfo ovh">
          <div class="commodityInfoLeft f_l">
            <!-- 商品轮播 -->
            <el-carousel height="350px">
              <el-carousel-item v-for="(item, index) in bannerList" :key="index">
                <img :src="item.src">
              </el-carousel-item>
            </el-carousel>
            <!-- 日历 -->
            <div class="calendar">
              <div class="calendar-box">
                <div class="calendar-body">
                  <div class="calendar-body-text">
                    <div style="cursor: pointer" @click="thePrevious"> 〈 </div>
                    <div class="text-title">{{timeValue}}</div>
                    <div style="cursor: pointer" @click="next"> 〉 </div>
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th v-for="(h, i) in teheadList" :key="i" :class="h == '六' || h == '日' ? 'col_1' : ''">{{h}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(b, i) in tbodyList" :key="i">
                        <td v-for="(o, index) in b" :key="index" :class="currentDay == (o.year + '-' + o.month + '-' + o.name) ? 'activeDay' : ''"
                          @click="changeData(o.year, o.month, o.name, index)">
                          <!--  -->
                          <div class="font" :class="o.class" v-if="o.name == 'default'">{{o.name}}</div>
                          <!-- 当天日期 -->
                          <div class="font" :class="o.class + (day == o.name ? '' : '')" v-else>{{o.name}}</div>
                          <!-- 金额 -->
                          <div :class="currentDay == (o.year + '-' + o.month + '-' + o.name) ? 'data_mo' : 'data_money'" v-if="o.money !== ''">￥{{o.money}}</div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <!-- 日历 -->
            <!-- <el-calendar v-model="data"></el-calendar> -->
          </div>
          <div class="commodityInfoRight f_r">
            <!-- 商品标题 -->
            <div class="info_title ovh">
              <div class="info_title_left f_l" v-if="address !== '' && address !== 'null' && address !== null">{{address}}</div>
              <div>{{goods_name}}</div>
            </div>
            <!-- 商品特点 -->
            <div class="info_characteristic ovh">
              <div class="f_l">{{goods_label}}</div>
            </div>
            <!-- 价格 -->
            <div class="info_money txt_a_l">
              ￥<span>{{price}}</span>起
            </div>
            <!-- 优惠信息 -->
            <div class="info_discount ovh m_19">
              <div class="info_discount_lable txt_a_l f_l">优惠信息</div>
              <div class="info_discount_txt f_l">{{coupon}}</div>
            </div>
            <!-- 雪票类型 -->
            <!-- <div class="info_discount ovh">
              <div class="info_discount_lable txt_a_l f_l">雪票类型</div>
              <div class="info_discount_list ovh">
                <div class="f_l info_discount_list_click">套票</div>
                <div class="f_l" v-for="(item, index) in 2" :key="index">雪票</div>
              </div>
            </div> -->
            <!-- 时长选择 -->
            <!-- <div class="info_discount ovh">
              <div class="info_discount_lable txt_a_l f_l">时长选择</div>
              <div class="info_discount_list ovh">
                <div class="f_l info_discount_list_click">半天</div>
                <div class="f_l" v-for="(item, index) in 6" :key="index">一天</div>
              </div>
            </div> -->
            <!-- 预定时间 -->
            <div class="info_discount ovh">
              <div class="info_discount_lable txt_a_l f_l">预定时间</div>
              <div class="info_discount_time ovh txt_a_l">{{today}}</div>
            </div>
            <!-- 开放时间 -->
            <div class="info_discount ovh">
              <div class="info_discount_lable txt_a_l f_l">开放时间</div>
              <div class="info_discount_lable w_100 ovh txt_a_l">{{timeOpenEnd}}</div>
            </div>
            <!-- 使用方式 -->
            <div class="info_discount ovh">
              <div class="info_discount_lable txt_a_l f_l">使用方式</div>
              <div class="info_discount_time ovh txt_a_l">请滑动底部查看</div>
            </div>
            <!-- 购买数量 -->
            <div class="info_discount ovh">
              <div class="info_discount_lable txt_a_l f_l">购买数量</div>
              <el-input class="f_l inputNum" v-model="number" type="number" @input="numInput" :disabled="true"></el-input>
              <div class="additionSubtraction f_l">
                <!-- 
                <div @click="topClick">
                  <img src="../../static/index/top.png" />
                </div> -->
                <!--  
                <div @click="botClick">
                  <img src="../../static/index/bottom.png" />
                </div>-->
              </div>
              <div class="info_discount_time f_l txt_a_l">库存{{stockNum}}件</div>
            </div>
            <!-- 购买按钮 -->
            <div class="buttonClass ovh">
              <div class="f_l txt_a_l">
                ¥<span>{{allMoney}}</span>
              </div>
              <div class="f_l" @click="pay">立即购买</div>
            </div>
          </div>
        </div>
        <!-- 详情tab -->
        <div class="detailTab ovh" :class="tabCode == 0 ? 'border' : ''">
          <div class="detailTabListAll f_l ovh">
            <div class="f_l" :class="[tabCode == item.code ? 'select' : '', tabCode - 1 == item.code ? 'tabFront' : '', tabCode + 1 == item.code ? 'tabAfter' : '']"
              v-for="(item, index) in detailTab" :key="index" @click="detailClick(item.code)">
              {{item.name}}
            </div>
            </div>
          </div>
        <!-- 详情内容 -->
        <div class="detailAll">
          <div v-if="tabCode !== 0" class="detailInfo" v-html="detailInfo"></div>
          <div v-if="tabCode == 0" class="detailInfo">
            <div class="detail_bot">【商家信息】</div>
            <div class="detail_bot">商家名称：{{businessDetail.name}}</div>
            <div class="detail_bot">雪场地点：{{businessDetail.address}}</div>
            <div class="detail_bot">营业时间：{{businessDetail.opening_hours}}</div>
            <div class="detail_bot">食宿介绍：{{businessDetail.ticketing}}</div>
            <div class="detail_bot">雪场门票：{{businessDetail.snow_road}}</div>
            <div>【费用包含】</div>
            <div class="detail_bot">{{businessDetail.note}}</div>
            <div v-html="detailInfo"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 下单支付 -->
    <mall-pay v-if="payVisble" ref="pay" @payReturn="payReturn"></mall-pay>
  </div>
</template>

<script>
  // 引入共用的css
	import "../components/css/component.css";

  // 顶部导航
  import MallHeader from '@/components/headTop.vue';
  // 底部
  import MallFotter from '@/components/fotter.vue';
  // 下单支付
  import MallPay from '@/components/payOrder.vue';

  // 调用的接口
  import { getGoodsPrice, getGoodsDetail, getSkiResortDeail } from '@/request/api.js';
  import { baseUrl } from '@/request/request.js'

  export default {
    name: 'commodityDetail',
    data () {
      return {
        id: null, // 商品id
        fieldId: null, // 学场id
        calendar_price_id: null, // 日期价格id
        bannerList: [{
          src: ''
        }], // 轮播图
        address: '', // 地址
        goods_name: '', // 商品名称
        goods_label: '', // 商品tab
        coupon: '', // 优惠
        today: '', // 预定时间
        timeOpenEnd: '', // 开放时间
        stockNum: null, // 库存数量
        data: new Date(), // 日历
        number: 1, // 数量
        price: 0, // 单价
        allMoney: 0, // 总价
        detailTab: [{
          code: 0,
          name: '商家信息'
        }, {
          code: 1,
          name: '费用说明'
        }, {
          code: 2,
          name: '使用说明'
        }, {
          code: 3,
          name: '其它说明'
        }, {
          code: 4,
          name: '退款说明'
        }],
        businessDetail: {}, // 商家所有信息
        businessInfo: '', // 商家信息
        cost_desc: '', // 费用说明
        use_desc: '', // 使用说明
        money_desc: '', // 其它说明
        refund_desc: '', // 退款说明
        detailInfo: '', // 底部详情
        goossPrice: [], // 后台返回的日历价格
        tabCode: 0, // 选中的值
        timeValue: '',
        teheadList: ['日', '一', '二', '三', '四', '五', '六'],
        year: '',
        month: 0,
        day: '',
        tbodyList: [],
        currentDay: '',
        payVisble: false // 下单支付弹框
      }
    },

    watch: {
      month() {
        if(this.month < 1) {
          this.month = 12;
          this.year --;
        }else if(this.month > 12){
          this.month = 1;
          this.year ++;
        }
        this.tbodyList = []
        this.timeValue = this.year + '年' + this.month + '月'
        this.handleAetCalendar()
      }
    },

    // 引用顶部,底部,下单支付
    components:{
      'mall-header': MallHeader, // 顶部导航
      'mall-fotter': MallFotter, // 底部导航
      'mall-pay': MallPay // 下单支付
    },

    mounted() {
      // 商品id
      // this.id = this.$route.params.id;
      this.id = localStorage.getItem('goodId');
      // 雪场id
      this.fieldId = localStorage.getItem('fieldId');
      // 当前时间
      this.getInitTime();
      // 获取日历价格
      this.getPrice();
      // 雪场信息（商家信息）
      this.getBusinessInfo();
      // 判断用户是否登录
      var name = localStorage.getItem('userName');
      if(name == null || name == 'null' || name == '' || name == undefined) {
        this.$message({
          showClose: true,
          message: '请在登录后查看'
        });
      }
    },

    computed:{
      
    },

    methods:{
      // 获取日历价格
      getPrice() {
        // 调用获取日历接口
        getGoodsPrice({
          goods_id: this.id, // 商品id
          category: 7, // 产品类型
          token: localStorage.getItem('token')
        }).then(res => {
          if(res.code == 0) {
            this.goossPrice = res.data;
            // 日历价格赋值
            this.mergeDataAndMoney();
          }
        })
      },

      // 根据id查看详情
      seeDetail() {
        // 详情接口
        getGoodsDetail({
          id: this.id, // 商品id
          date: this.currentDay, // 用户选中的日期
          token: localStorage.getItem('token')
        }).then(res => {
          if(res.code == 0) {
            var row = res.data;
            this.bannerList[0].src = baseUrl() + row.goods_banner; // 商品图片
            this.address = row.address; // 地址
            this.goods_name = row.goods_name; // 商品名称
            this.goods_label = row.label; // 商品tab
            this.price = row.price; // 单价
            this.allMoney = row.price * this.number; // 总价
            this.coupon = row.coupon; // 优惠
            this.today = row.date; // 预定时间
            this.timeOpenEnd = row.open_time + '~' + row.end_time; // 开放时间
            this.stockNum = row.stock; // 库存
            this.cost_desc = row.cost_desc; // 费用说明
            this.use_desc = row.use_desc; // 使用说明
            this.money_desc = row.money_desc; // 其它说明
            this.refund_desc = row.refund_desc; // 退款说明
          }
        })
      },

      // 雪场信息（商家信息）
      getBusinessInfo() {
        getSkiResortDeail({
          id: this.fieldId // 雪场id
        }).then(res => {
          if(res.code == 0) {
            var row = res.data;
            this.businessDetail = row;
            this.businessInfo = row.field_introduce;
            // 详情tab点击
            this.detailClick(0);
          }
        })
      },

      // 点击购买按钮
      pay() {
        // 判断用户是否登录
        var name = localStorage.getItem('userName');
        if(name == null || name == 'null' || name == '' || name == undefined) {
          this.$message({
            showClose: true,
            message: '请先登录'
          });
          return
        }
        // 跳转订单
        this.$router.push({
          name: 'orderPay',
          params: {
            'id': this.id, // 商品id
            'calendar_price_id': this.calendar_price_id, // 日期价格id
            'currentDay': this.currentDay // 日期
          }
        })
        // 下单支付弹框出现
        // this.payVisble = true;
        // this.$nextTick(() => {
        //   this.$refs.pay.init()
        // })
      },

      // 下单支付弹框关闭
      payReturn() {
        // 下单支付弹框隐藏
        this.payVisble = false;
      },

      // 选择选择的日期
      changeData(year, month, name, index) {
        // 用户选中时间赋值
        this.currentDay = year + '-' + month + '-' + name;
        // 用户选中的价格id
        for(var i in this.tbodyList) {
          for(let k in this.tbodyList[i]) {
            if(this.tbodyList[i][k].year == year && this.tbodyList[i][k].month == month && this.tbodyList[i][k].name == name) {
              // 日期价格id
              this.calendar_price_id = this.tbodyList[i][k].id;
              break;
            }
          }
        }
        // 根据id查看详情
        this.seeDetail();
      },

      // 上个月
      thePrevious() {
        this.month--;
        // 获取日历价格
        this.getPrice();
      },

      // 下个月
      next() {
        this.month++;
        // 获取日历价格
        this.getPrice();
      },

      // 当前日期
      getInitTime() {
        let date = new Date();
        this.year = date.getFullYear();  // 获取当年
        this.month = date.getMonth() + 1;  // 获取本月
        this.day = date.getDate();       // 获取当天
        this.timeValue = date.getFullYear() + '年' + (date.getMonth() + 1) + '月'
        // 生成档期数据
        this.handleAetCalendar();
        // 选择选择的日期
        this.changeData(this.year, this.month, this.day);
      },

      // 生成档期数据
      handleAetCalendar() {
          this.tbodyList = [];
          let days = new Date(this.year, this.month, 0).getDate()  // 当月总天数
          let week = new Date(this.year, this.month-1, 1).getDay() // 当月有几周
          let last_month = new Date(this.year, this.month + 1, 0).getDate()  // 当月的上一个月的最后一天
          this.tbodyList[0] = [];
          for(let i = 0; i < Math.ceil((days + week) / 7) *7; i++) {
            let nub = Math.floor(i / 7);
            if(i<week) {
              this.tbodyList[nub].push({
                year: this.year,
                class: 'default', 
                name: last_month+i-week+1,
                month: this.month == 0 ? 12 : this.month -1,
                money: ''
              })
            }else {
              if(!this.tbodyList[nub]) {
                this.tbodyList[nub] = [];
              }
              let day = i - week +1;
              let calssName = 'actives'
              let month = this.month;
              if(day > days) {
                day -= days;
                calssName = 'default';
                month = this.month + 1 > 12 ? 1 : this.month+1
              }
              this.tbodyList[nub].push({
                year: this.year,
                class: calssName, 
                name: day,
                month: month,
                money: ''
              })
            }
          }
          let arr = this.tbodyList[Math.floor( (week + days) /7)];
          if(arr && arr.length !== 7 ){
            this.tbodyList[Math.floor( (week+days) / 7)] = arr.concat(new Array(7 - arr.length).fill(""))
          }
      },

      // 日历价格赋值
      mergeDataAndMoney() {
        var arr = this.tbodyList;
        var goodsList = this.goossPrice;
        for(let o in goodsList) {
          let reg = new RegExp('-0','g');
          goodsList[o].datetime = goodsList[o].datetime.replace(reg, '-');
        }
        for(let i in arr) {
          for(let j in arr[i]) {
            goodsList.findIndex(item => {
              if(item.datetime === (arr[i][j].year + '-' + arr[i][j].month + '-' + arr[i][j].name)) {
                arr[i][j].id = item.id;
                arr[i][j].money = item.price;
              }
            })
          }
        }
        this.tbodyList = [];
        this.tbodyList = arr;
        // 默认第一个id
        for(var i in this.tbodyList) {
          for(let k in this.tbodyList[i]) {
            if(this.tbodyList[i][k].year == this.year && this.tbodyList[i][k].month == this.month && this.tbodyList[i][k].name == this.day) {
              // 日期价格id
              this.calendar_price_id = this.tbodyList[i][k].id;
              break;
            }
          }
        }
      },

      // 监听用户输入的数量是否是正整数
      numInput(e) {
        if(e == '' || e < 1) {
          this.number = 1;
        }
        if(parseInt(e) > this.stockNum) {
          this.number = this.stockNum;
        }
        // 总价
        this.allMoney = this.number * this.price;
      },

      // 详情tab点击
      detailClick(code) {
        this.tabCode = code;
        // 判断用户点击的是那种
        if(code == 0) {
          // 费用说明
          this.detailInfo = this.businessInfo;
        }else if(code == 1) {
          // 费用说明
          this.detailInfo = this.cost_desc;
        }else if(code == 2) {
          // 使用说明
          this.detailInfo = this.use_desc;
        }else if(code == 3) {
          // 其它说明
          this.detailInfo = this.money_desc;
        }else if(code == 4) {
          // 退款说明
          this.detailInfo = this.refund_desc;
        }
      },

      // 加
      topClick() {
        this.number++;
        this.numInput(this.number);
      },

      // 减
      botClick() {
        this.number--;
        this.numInput(this.number);
      },

      // 点击返回首页
      goIndex() {
        this.$router.push({
          name: 'index',
          params: {}
        })
      },
    }
  }
</script>

<!-- 样式 -->
<style scoped lang="scss">
  .calendar {
    width: 100%;
    background: #FAFCFF;
    margin: 31px 0 20px 0;
    padding: 29px 14px;
    box-sizing: border-box;
    border-radius: 19px 19px 0px 0px;
    cursor: pointer;
    .calendar-box {
      width: 100%;
      height: 100%;
      position: relative;
      .calendar-body {
        width: 100%;
        margin: 0 auto;
        .calendar-body-text {
          width: 100%;
          height: 30px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          color: #434444;
          font-weight: bold;
          font-size: 25px;
          margin-bottom: 17px;
          .text-title {
            margin: 0 20px;
          }
        }
      }
      table tr th{
        color: #ccc;
      }
      table tr th, table tr td {
        width: 130px;
        height: 66px;
      }
      table td {
        &.activeDay {
          background-color: #FF7702;
          border-radius: 4px;
          font-size: 22px;;
        }
        .currentMonth {
          color: #00BFFF
        }
        .data_money {
          font-size: 18px;
          color: #DF0002;
        }
        .data_mo {
          font-size: 18px;
          color: #fff;
        }
      }
      table td span{
        color: #333;
        cursor: pointer;
      }
      table td span.default{
        color: #e9e9e9;
      }
  }
  }
  .content {
    min-width: 1200px;
    padding: 50px 0 530px 0;
    .content_detail {
      width: 1200px;
      margin: 0 auto;
      // 页面标题
      &> .pageTitle {
        padding: 36px 0 20px 0;
        &> .pageTitleList {
          margin-right: 48px;
          &> .pageTitleListTable {
            color: #434444;
            font-size: 24px;
          }
          &> .pageTitleListImg {
            margin-left: 18px;
            width: 14px;
            height: 20px;
            margin-top: 7px;
          }
        }
        &> .pageTitleList:first-child > .pageTitleListTable {
          color: #0F7DFF;
          cursor: pointer;
        }
      }
      // 日历及信息
      &> .commodityInfo {
        // 日历
        &> .commodityInfoLeft {
          width: 600px;
        }
        // 信息
        &> .commodityInfoRight {
          width: 552px;
          &> .info_title {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #484949;
            line-height: 33px;
            text-align: justify;
            font-weight: bold;
            &> .info_title_left {
              font-size: 19px;
              width: 38px;
              height: 26px;
              line-height: 26px;
              background: #0F7DFF;
              border-radius: 4px;
              color: #fff;
              padding: 0 6px;
              margin: 5px 15px 0 0;
            }
          }
          // 商品特点
          &> .info_characteristic {
            padding: 12px 0 16px 0;
            &> div {
              background: #EBF4FF;
              border-radius: 4px;
              border: 1px solid #0F7DFF;
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #0F7DFF;
              line-height: 20px;
              padding: 0 6px;
              margin-right: 12px;
            }
            &> div:last-child {
              margin-right: 0;
            }
          }
          // 商品起步价
          &> .info_money {
            font-size: 14px;
            width: 100%;
            height: 70px;
            line-height: 70px;
            background: #EBF4FF;
            color: #FF7702;
            padding: 0 22px;
            span {
              font-size: 32px;
            }
          }
          // 商品优惠信息
          &> .info_discount {
            &> .info_discount_lable {
              color: #484949;
              letter-spacing: 1px;
              font-size: 20px;
              font-weight: bold;
              width: 100px;
              height: 75px;
              line-height: 75px;
            }
            &> .info_discount_txt {
              height: 25px;
              line-height: 25px;
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #DF0002;
              line-height: 25px;
              letter-spacing: 1px;
              border-radius: 4px;
              border: 2px solid #DF0002;
              padding: 0 14px;
              margin-top: 23px;
            }
            &> .info_discount_list {
              margin-top: 23px;
              margin-left: 100px;
              div {
                width: 50px;
                height: 25px;
                line-height: 25px;
                border-radius: 4px;
                border: 1px solid #979797;
                padding: 2px 9px;
                margin-right: 13px;
                margin-bottom: 14px;
              }
              div:last-child {
                margin-right: 0;
              }
              .info_discount_list_click {
                background: #FF7702;
                color: #fff;
                border: 1px solid #FF7702;
              }
            }
            // 预定时间
            &> .info_discount_time {
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #484949;
              line-height: 26px;
              height: 75px;
              line-height: 75px;
            }
            &> .inputNum {
              width: 90px;
              height: 40px;
              margin: 16px 10px 0 0;
            }
            &> .w_100 {
              width: 452px;
            }
            // 加减
            &> .additionSubtraction {
              margin: 16px 16px 0 0;
              &> div {
                width: 16px;
                height: 16px;
                border-radius: 3px;
                border: 1px solid #979797;
              }
              &> div:first-child {
                margin-bottom: 2px;
              }
            }
          }
          // 按钮
          &> .buttonClass {
            width: 100%;
            margin-top: 60px;
            div:first-child {
              width: 58%;
              height: 66px;
              line-height: 66px;
              border: 2px solid #979797;
              border-right: 0 !important;
              padding: 0 22px;
              box-sizing: border-box;
              font-size: 16px;
              color: #FF7702;
              font-webkit: bold;
              span {
                font-size: 32px;
              }
            }
            div:last-child {
              cursor: pointer;
              width: 41%;
              height: 66px;
              line-height: 66px;
              background: #FF7702;
              font-size: 30px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              letter-spacing: 1px;
            }
          }
        }
      }
      // 详情tab
      &> .detailTab {
        border-top: 10px solid #0F7DFF;
        border-radius: 8px;
        background: #0F7DFF;
        cursor: pointer;
        &> .detailTabListAll {
          background: #fff;
          &> div {
            height: 70px;
            line-height: 70px;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            padding: 0 7px;
            background-color: #0F7DFF;
          }
          &> .select {
            background: #fff;
            font-size: 22px;
            color: #434444;
            // border-top-left-radius: 10px;
            // border-top-right-radius: 10px;
          }
          &> div:first-child > .select {
            border-top-left-radius: 0;
          }
          &> .tabFront {
            border-bottom-right-radius: 8px;
          }
          &> .tabAfter {
            border-bottom-left-radius: 8px;
          }
        }
      }
      &> .border {
        border-bottom-left-radius: 0;
      }
      // 详情
      &> .detailAll {
        margin-top: 27px;
        .detailInfo {
          font-size: 22px;
          text-align: left;
          &p {
            font-size: 22px;
            & span {
              font-size: 22px;
            }
          }
          &> .detail_bot {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
  .font {
    font-size: 22px;
  }
  .m_19 {
    margin-top: 19px;
  }
  .el-carousel__item.is-active {
    z-index: 0;
  }
  .col_1 {
    color: #0F7DFF !important;
  }
</style>
<style scoped lang="">

  .el-radio__input.is-checked+.el-radio__label {
    color: #fff;
  }

  .el-radio__input.is-checked .el-radio__inner {
    border-color: #FE951E;
    background: #FE951E;
  }

  .el-radio__label {
    font-size: 16px !important;
    letter-spacing: 1px;
    color: #fff;
  }

  .el-calendar-table .el-calendar-day {
    padding: 2px;
  }

  .el-calendar-table .el-calendar-day {
    height: 66px;
  }

  .inputNum > input:focus{border: 1px solid #DCDFE6 !important;}

  .inputNum > input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  .inputNum > input[type="number"]{
    -moz-appearance: textfield;
  }
</style>



// WEBPACK FOOTER //
// src/page/commodityDetail.vue